import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";

const IconBtn = ({ icon, className, onClick }) => {
  return <Icon icon={icon} className={className} onClick={onClick} />;
};

export default IconBtn;
